import { Navigate } from 'react-router-dom'
// Gate 1 integration fix: consumes CostSpace's single AuthContext (the one
// authenticated session for the whole app) instead of Estimation's own,
// now-removed AuthProvider. CostSpace's useAuth() returns a superset of
// the same shape this component always relied on ({ user, loading }), so
// no other logic here changes.
import { useAuth } from '../../context/AuthContext'

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth()

  if (loading) {
    return <div style={{ padding: 24 }}>Loading...</div>
  }

  if (!user) {
    // Relative -- resolves to /estimation/login now that this app is
    // mounted under /estimation/* inside CostSpace's single BrowserRouter,
    // instead of the absolute /login (which no CostSpace route owns).
    return <Navigate to="login" replace />
  }

  return children
}
